module.exports = __webpack_public_path__ + "static/fonts/notokr-bold.84cf469.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/singapore/font/notokr-bold.woff
// module id = SsEW
// module chunks = 0